import { render, staticRenderFns } from "./ProductWhiteListEditOrDetail.vue?vue&type=template&id=db972a98&"
import script from "./ProductWhiteListEditOrDetail.vue?vue&type=script&lang=js&"
export * from "./ProductWhiteListEditOrDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductWhiteListEditOrDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports